import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CONTENT_DISPOSITION, CONTENT_TYPE, METHOD } from '../../constants/method';
import PleaseWait from '../Shared/PleaseWait';
import Alert from './Alert';
import { callApi } from '../../util/apiWrapper';
import { Grid } from '@material-ui/core';

const Resource = ({ authStore, onDownloadComplete }) => {
  const [resourceId, setResourceId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('id')) {
      setResourceId(params.get('id'));
    }
  }, []);

  const downloadFile = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      setMessage(null);

      if (!resourceId) {
        setError('Missing id: No resource id provided!');
        return;
      }
      if (typeof resourceId !== 'string' || !/^\d+$/.test(resourceId)) {
        setError(`Invalid id: '${String(resourceId) || 'undefined'}' is not valid`);
        return;
      }

      const response = await callApi(authStore, `resources/${resourceId}/download`, METHOD.GET, null, CONTENT_TYPE.APPLICATION_PDF);

      const blob = await response.blob();

      if (blob.size === 0 || blob.type !== 'application/pdf') {
        setError('Invalid file: The downloaded file is empty or not a valid PDF.');
        return;
      }

      const contentDisposition = response.headers?.get(CONTENT_DISPOSITION);
      const suggestedFileName = contentDisposition
        ? contentDisposition.split('filename=')[1].replace(/"/g, '')
        : `Resource_${resourceId || 'unknown'}.pdf`;

      const fileURL = URL.createObjectURL(blob);
      const anchorElement = document.createElement('a');
      anchorElement.href = fileURL;
      anchorElement.download = suggestedFileName;
      document.body.appendChild(anchorElement);
      anchorElement.click();
      anchorElement.remove();
      URL.revokeObjectURL(fileURL);

      if (!onDownloadComplete) {
        setMessage(`Download completed: File Name: ${suggestedFileName}`);
      } else {
        onDownloadComplete();
      }
    } catch (err) {
      setError(err.message.includes('404') ? `Resource not found: Resource with id =${resourceId} not found!` : err.message);
    }
  }, [authStore, resourceId]);

  useEffect(() => {
    if (resourceId) {
      downloadFile().then(() => setLoading(false));
    }
  }, [resourceId, downloadFile]);

  return (
    <>
      <Grid container direction="row" justifyContent="center" alignItems="center" style={{ marginLeft: '20px' }}>
        <PleaseWait isLoading={loading} />
        {!!error && <Alert severity="error" message={error} />}
        {!!message && <Alert severity="info" message={message} />}
      </Grid>
    </>
  );
};

Resource.propTypes = {
  authStore: PropTypes.object.isRequired,
  onDownloadComplete: PropTypes.func,
};

export default Resource;
